import * as React from "react";
import { useState } from "react";
import classNames from "classnames";
import { UnmountClosed } from "react-collapse";
import { ModelPortfolioTabType } from "../../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { InstrumentSearchQuery } from "../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
import { AutoComplete } from "./AutoComplete";
import { RestrictionStore } from "../../../../Dashboard/Components/Clients/Common/Restrictions/Variable";
import { ResearchISTDispatcher } from "../../../../Dashboard/Components/ToolsAndLiterature/Store/Variable";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { InvestmentDetailsPopupModal } from "../../../../Dashboard/Components/Clients/Common/InvestmentDetailsPopUp/InvestmentDetailsPopupModal";
import { Investment } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";

interface IAdvancedSearchProps {
    hiercharyId: string;
    query: InstrumentSearchQuery;
    children?: any;
    placeholder?: string;
    modelPortfolioType?: ModelPortfolioTabType;
    index?: number;
    cssWrapper?: string;
    showResult?: any;
    forceAdvanced?: boolean;
    showAutoComplete?: boolean;
    ProductTypes? : ProductType;
    selectedPathwayText? : string;
}

export const AdvancedSearch = (props: IAdvancedSearchProps) => {
    const { 
        hiercharyId, 
        query, 
        children, 
        placeholder, 
        modelPortfolioType, 
        index, 
        cssWrapper, 
        showResult, 
        forceAdvanced = false,
        showAutoComplete = true,
        selectedPathwayText
    } = props;

    const [isShowDetailModal, setShow] = React.useState(false);
    const [selectedInvestment, setSelected] = React.useState<Investment>(null);
    const [showAdvanced, setShowAdvanced] = useState(false);

    const cssWrapperClass = classNames("advanced-search", props.cssWrapper);

    const AdvancedToggle = () => {
        setShowAdvanced(!showAdvanced);
    };
    const onInvestmentSelected = (investment) => {
        InvestmentSelectionAction.getUnitPrice(investment, (d) => {
            setSelected(d);   
            setShow(true);       
        });
    };
    const renderInvestmentDetailPopupModal = (): JSX.Element => {
        if (!isShowDetailModal) return null;
        console.log(selectedInvestment)
        return (
            <>
                <InvestmentDetailsPopupModal
                    showBox={isShowDetailModal}
                    callBack={() => {
                        setShow(false);
                    }}
                    instrumentCode={selectedInvestment?.InstrumentCode}
                    productId={selectedInvestment?.ProductId}
                    instrumentName={selectedInvestment?.DisplayName}
                    unitCost={selectedInvestment?.UnitCost}
                    securityType={selectedInvestment?.Type}
                    unitPrice={selectedInvestment?.UnitPrice}
                />
            </>
        );
    };

    return (
        <>
            <div className={cssWrapperClass}>
                {showAutoComplete && (
                    <>
                    <AutoComplete
                        placeholder={props.placeholder || "Search"}
                        label="Search"
                        query={props.query}
                        hiercharyId={props.hiercharyId}
                        onSelected={(investment) => {
                            ResearchISTDispatcher.dispatch({ actionType: ActionType.Update, payload: null });
                            if (props.showResult && props.showResult.current) {props.showResult.current.close();}
                            InvestmentSelectionAction.addInvestment(investment, props.modelPortfolioType);
                            if (props.index) {InvestmentSelectionAction.setEditingTransferNumber(props.index);}
                            if(props.ProductTypes == ProductType.OffPlatform){
                                onInvestmentSelected(investment)
                            }
                        }}
                        onLookupError={() => {}}
                        cssWrapper="label-sr-only submit-is-magnifier-glass mb-0"
                        disabled={RestrictionStore.buyDisabled()}
                        selectedPathwayText={props.selectedPathwayText}
                    />
                    <button
                        className="ist-advanced-toggle"
                        type="button"
                        onClick={() => AdvancedToggle()}
                        aria-expanded={showAdvanced}
                    >
                        {showAdvanced ? "Basic search" : "Advanced search"}
                    </button>
                    </>
                )}
                <UnmountClosed isOpened={props.forceAdvanced || showAdvanced}>{props.children}</UnmountClosed>
                {renderInvestmentDetailPopupModal()}
            </div>
        </>
    );
};
